import { useDocumentDiagnostics } from "~/stores/document-diagnostics/useDocumentDiagnostics";

export const useDocumentDiagnosticsStore = (documentId: string) => {
  return useDocumentDiagnostics(documentId)();
};
